/* Extracted from sections/screen-calculator.liquid. Living in a section {% javascript %} block meant this
   shipped inside the theme-wide bundle on every page of the site, including the ones that have
   no screen-calculator on them at all. As an asset it only downloads where the section renders.
   The tag that pulls it in sits inside the section, so a page holding the section twice would
   run this twice and double-bind every listener. The flag keeps the second copy a no-op, which
   is what the old shared bundle did by construction. */
if (!window.__cht_screen_calculator) {
  window.__cht_screen_calculator = true;
(function () {
  var root = document.querySelector('[data-scalc]');
  if (!root) return;
  var RATIOS = { '16:9': 16 / 9, '2.35:1': 2.35, '2.4:1': 2.4, '16:10': 16 / 10, '4:3': 4 / 3 };
  var F = { 'in': 2.54, 'cm': 1 };
  // AU default: diagonal in inches, width/height/frame in cm.
  var state = { ar: '16:9', mode: 'diag', cm: 120 * 2.54, frameCm: 0, u: { diag: 'in', width: 'cm', height: 'cm', frame: 'cm' } };

  function toCm(v, u) { return v * F[u]; }
  function fromCm(cm, u) { return Math.round((cm / F[u]) * 10) / 10; }
  function show(cm, u) { return fromCm(cm, u) + ' ' + u; }

  function dims() {
    var r = RATIOS[state.ar], v = state.cm, W, H, D;
    if (state.mode === 'width') { W = v; H = W / r; }
    else if (state.mode === 'height') { H = v; W = H * r; }
    else { D = v; H = D / Math.sqrt(r * r + 1); W = H * r; }
    D = Math.sqrt(W * W + H * H);
    return { W: W, H: H, D: D };
  }
  function q(s) { return root.querySelector(s); }
  function qa(s) { return Array.prototype.slice.call(root.querySelectorAll(s)); }

  /* ---- analytics ----
     Same envelope as every other tool: one event, a tool key, an action. Local rather than
     shared, because section javascript blocks concatenate in an unspecified order. */
  function track(action, data) {
    try {
      var d = Object.assign({ event: 'cht_tool', tool: 'screen_calculator', action: action }, data || {});
      (window.dataLayer = window.dataLayer || []).push(d);
      window.dispatchEvent(new CustomEvent('cht:tool', { detail: d }));
    } catch (e) {}
  }
  var _scEngaged = false;
  function trackEngage(how) { if (_scEngaged) return; _scEngaged = true; track('engage', { how: how }); }
  function scSnapshot() { try { var d = dims(); return { ar: state.ar, diagonal_in: Math.round(d.D / 2.54), width_cm: Math.round(d.W) }; } catch (e) { return { ar: state.ar }; } }

  var announceT;
  function announce(d) {
    clearTimeout(announceT);
    announceT = setTimeout(function () {
      var n = q('[data-scalc-announce]');
      if (n) n.textContent = 'Diagonal ' + show(d.D, state.u.diag) + ', width ' + show(d.W, state.u.width) + ', height ' + show(d.H, state.u.height);
    }, 400);
  }
  function render() {
    var d = dims(), m = { diag: d.D, width: d.W, height: d.H };
    announce(d);
    qa('[data-in]').forEach(function (el) {
      var k = el.getAttribute('data-in');
      if (k === 'frame') return;
      if (document.activeElement === el) return;
      el.value = fromCm(m[k], state.u[k]);
      // This field now holds a valid calculated number, so it can no longer be the bad one.
      var row = el.closest('.scalc-inputrow');
      if (row) row.classList.remove('is-invalid');
    });
    refreshInvalidChrome();
    q('[data-out="diag"]').textContent = show(d.D, state.u.diag);
    q('[data-out="width"]').textContent = show(d.W, state.u.width);
    q('[data-out="height"]').textContent = show(d.H, state.u.height);
    // "Also" line = each dimension in its opposite unit
    var od = state.u.diag === 'in' ? 'cm' : 'in', ow = state.u.width === 'in' ? 'cm' : 'in', oh = state.u.height === 'in' ? 'cm' : 'in';
    q('[data-out="alt"]').textContent = 'Diagonal ' + show(d.D, od) + ' · W ' + show(d.W, ow) + ' · H ' + show(d.H, oh);

    var fo = q('[data-frameout]');
    if (state.frameCm > 0) {
      q('[data-out="oWidth"]').textContent = show(d.W + 2 * state.frameCm, state.u.width);
      q('[data-out="oHeight"]').textContent = show(d.H + 2 * state.frameCm, state.u.height);
      fo.hidden = false;
    } else { fo.hidden = true; }

    var scr = q('[data-preview-screen]'), frm = q('[data-preview-frame]');
    var r = RATIOS[state.ar], pw = 260, ph = pw / r;
    if (ph > 150) { ph = 150; pw = ph * r; }
    scr.style.width = Math.round(pw) + 'px';
    scr.style.height = Math.round(ph) + 'px';
    q('[data-preview-ar]').textContent = state.ar;
    frm.style.padding = (state.frameCm > 0 ? Math.max(3, Math.min(16, (state.frameCm / d.W) * pw)) : 8) + 'px';

    var seat = q('[data-seat]');
    if (root.getAttribute('data-seating') === 'true') {
      var wM = d.W / 100;
      var thx = wM / (2 * Math.tan(18 * Math.PI / 180));
      var smpte = wM / (2 * Math.tan(15 * Math.PI / 180));
      q('[data-out="seat"]').textContent = (Math.round(thx * 10) / 10) + '–' + (Math.round(smpte * 10) / 10) + ' m';
      seat.hidden = false;
    } else { seat.hidden = true; }
  }

  function setLockUI() {
    qa('.scalc-dim').forEach(function (el) {
      var on = el.getAttribute('data-dim') === state.mode;
      el.classList.toggle('is-locked', on);
      var lk = el.querySelector('.scalc-lock'); if (lk) lk.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  qa('[data-scalc-ar] .scalc-seg__b').forEach(function (b) {
    b.addEventListener('click', function () {
      qa('[data-scalc-ar] .scalc-seg__b').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
      b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true'); state.ar = b.getAttribute('data-ar'); trackEngage('aspect'); render(); try { root.dispatchEvent(new Event('input', { bubbles: true })); } catch (e) {}
    });
  });
  // per-field unit toggles
  qa('.scalc-uu').forEach(function (grp) {
    var field = grp.getAttribute('data-uu');
    grp.querySelectorAll('[data-uu-b]').forEach(function (b) {
      b.addEventListener('click', function () {
        grp.querySelectorAll('[data-uu-b]').forEach(function (x) { x.classList.remove('is-on'); x.setAttribute('aria-pressed', 'false'); });
        b.classList.add('is-on'); b.setAttribute('aria-pressed', 'true');
        state.u[field] = b.getAttribute('data-uu-b');
        if (field === 'frame') { q('[data-in="frame"]').value = fromCm(state.frameCm, state.u.frame); }
        render();
      });
    });
  });
  // Show a "waiting for a valid number" state instead of leaving a stale result on screen.
  function refreshInvalidChrome() {
    var anyBad = qa('.scalc-dim [data-in]').some(function (x) {
      var r = x.closest('.scalc-inputrow'); return r && r.classList.contains('is-invalid');
    });
    var out = q('[data-scalc-out]'), note = q('[data-scalc-invalid]');
    if (out) out.classList.toggle('is-stale', anyBad);
    if (note) note.hidden = !anyBad;
  }
  function setInvalid(el, bad) {
    var row = el.closest('.scalc-inputrow');
    if (row) row.classList.toggle('is-invalid', bad);
    refreshInvalidChrome();
  }
  qa('[data-in]').forEach(function (el) {
    var k = el.getAttribute('data-in');
    el.addEventListener('input', function () {
      var val = parseFloat(el.value);
      if (k === 'frame') { state.frameCm = (isFinite(val) && val > 0) ? toCm(val, state.u.frame) : 0; render(); return; }
      if (!isFinite(val) || val <= 0) { setInvalid(el, true); return; }
      setInvalid(el, false);
      trackEngage('dimension');
      state.mode = k; state.cm = toCm(val, state.u[k]); setLockUI(); render();
    });
    // Leaving a field empty or negative used to strand the whole panel: the row kept
    // its is-invalid class forever, so the results stayed greyed out and the alert
    // stayed on screen no matter what was typed anywhere else. Put the calculated
    // value back on blur and clear the flag.
    el.addEventListener('blur', function () {
      var val = parseFloat(el.value);
      if (k === 'frame') {
        if (!isFinite(val) || val < 0) { state.frameCm = 0; el.value = 0; render(); }
        return;
      }
      if (isFinite(val) && val > 0) return;
      var d = dims(), m = { diag: d.D, width: d.W, height: d.H };
      el.value = fromCm(m[k], state.u[k]);
      setInvalid(el, false);
      render();
    });
  });
  qa('.scalc-lock').forEach(function (b) {
    b.addEventListener('click', function () {
      var k = b.getAttribute('data-lock');
      if (!k || k === state.mode) return;
      // Locking a different dimension must not resize the screen: carry the CURRENT value of
      // the newly-locked dimension into state.cm, or dims() reinterprets the old magnitude
      // (e.g. a 120" diagonal read as a 120" height) and every figure blows out.
      var d = dims(), m = { diag: d.D, width: d.W, height: d.H };
      if (!isFinite(m[k]) || m[k] <= 0) return; // inputs invalid: don't switch modes on a value we can't carry
      state.cm = m[k];
      state.mode = k; setLockUI(); render();
    });
  });

  /* ---- shareable link ----
     Five values describe the whole screen, so the link is short and every one of them is
     re-checked against what the controls actually offer before it is applied. */
  function shareGet() {
    return { ar: state.ar, mode: state.mode, cm: Math.round(state.cm * 100) / 100, frame: Math.round(state.frameCm * 100) / 100, u: state.u };
  }
  function shareSet(o) {
    if (!o) return;
    if (o.ar && RATIOS[o.ar]) state.ar = o.ar;
    if (o.mode === 'diag' || o.mode === 'width' || o.mode === 'height') state.mode = o.mode;
    var cm = parseFloat(o.cm);
    if (isFinite(cm) && cm > 0 && cm < 20000) state.cm = cm;
    var fr = parseFloat(o.frame);
    state.frameCm = (isFinite(fr) && fr > 0 && fr < 200) ? fr : 0;
    if (o.u) {
      ['diag', 'width', 'height', 'frame'].forEach(function (k) {
        if (o.u[k] === 'in' || o.u[k] === 'cm') state.u[k] = o.u[k];
      });
    }
    /* The aspect strip and the per-field unit toggles keep their pressed state in the DOM,
       so restoring state alone would leave the buttons describing the previous screen. */
    qa('[data-scalc-ar] .scalc-seg__b').forEach(function (b) {
      var on = b.getAttribute('data-ar') === state.ar;
      b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    qa('.scalc-uu').forEach(function (grp) {
      var field = grp.getAttribute('data-uu');
      grp.querySelectorAll('[data-uu-b]').forEach(function (b) {
        var on = b.getAttribute('data-uu-b') === state.u[field];
        b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
    });
    var fin = q('[data-in="frame"]');
    if (fin) fin.value = fromCm(state.frameCm, state.u.frame);
    setLockUI(); render();
  }
  (function () {
    var reg = { key: 'screen_calculator', get: shareGet, set: shareSet };
    if (window.CHTToolShare) window.CHTToolShare(reg);
    else (window.CHTToolShareQ = window.CHTToolShareQ || []).push(reg);
  })();

  var _scCta = q('.scalc-cta');
  if (_scCta) _scCta.addEventListener('click', function () { track('shop_click', scSnapshot()); });
  /* ---- print sheet (shared tool-print button + Cmd/Ctrl-P) ----
     All three dimensions in both unit systems (the on-screen rows carry the chosen unit, the
     "Also" line the opposite one), plus frame, seating range and the lock, from live state. */
  function psEsc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function fillPrintSheet() {
    var el = q('[data-scalc-printsheet]'); if (!el) return;
    var inv = q('[data-scalc-invalid]');
    if (inv && !inv.hidden) { el.innerHTML = '<p class="scalc-ps__note">Enter a valid measurement, then print to take the sheet with you.</p>'; return; }
    function kv(l, v) { return '<div class="scalc-ps__kv"><span>' + psEsc(l) + '</span><b>' + psEsc(v) + '</b></div>'; }
    var d = dims();
    var locked = root.querySelector('.scalc-dim.is-locked');
    var h = '<div class="scalc-ps__grid">';
    h += '<div class="scalc-ps__block"><p class="scalc-ps__lab">Screen — ' + psEsc(state.ar) + '</p>';
    h += kv('Diagonal', show(d.D, 'in') + ' · ' + show(d.D, 'cm'));
    h += kv('Width', show(d.W, 'cm') + ' · ' + show(d.W, 'in'));
    h += kv('Height', show(d.H, 'cm') + ' · ' + show(d.H, 'in'));
    if (locked) h += kv('Locked dimension', locked.getAttribute('data-dim') + ' (kept fixed when the aspect ratio changes)');
    h += '</div>';
    if (state.frameCm > 0) {
      h += '<div class="scalc-ps__block"><p class="scalc-ps__lab">Outer size incl. frame</p>';
      h += kv('Frame thickness', show(state.frameCm, state.u.frame));
      h += kv('Outer width', show(d.W + 2 * state.frameCm, 'cm') + ' · ' + show(d.W + 2 * state.frameCm, 'in'));
      h += kv('Outer height', show(d.H + 2 * state.frameCm, 'cm') + ' · ' + show(d.H + 2 * state.frameCm, 'in'));
      h += '</div>';
    }
    var seat = q('[data-out="seat"]');
    if (seat && seat.textContent.trim() && root.getAttribute('data-seating') === 'true') {
      h += '<div class="scalc-ps__block"><p class="scalc-ps__lab">Typical seating distance</p>';
      h += kv('Range', seat.textContent.trim());
      h += '<p class="scalc-ps__sub">From immersive (the image spans ~36°, the THX guide) to relaxed (~30°, SMPTE). A guide only — room, content and taste vary.</p></div>';
    }
    h += '</div>';
    el.innerHTML = h;
  }
  document.addEventListener('click', function (e) { if (e.target && e.target.closest && e.target.closest('[data-toolprint-btn]')) fillPrintSheet(); }, true);
  window.addEventListener('beforeprint', fillPrintSheet);

  /* My System: a plain open (no #s= share link) starts from the screen the visitor already has
     in their plan; every edit writes the diagonal and ratio back for the projector tools. */
  var _scReady = false, _scT = null;
  try {
    if (window.CHT && CHT.system && !/[#&]s=/.test(location.hash || '')) {
      var _ss = CHT.system.part('screen') || {};
      if (_ss.diag >= 40 && _ss.diag <= 300) {
        state.mode = 'diag'; state.cm = _ss.diag * 2.54;
        if (_ss.ar && RATIOS[_ss.ar]) { state.ar = _ss.ar; qa('[data-scalc-ar] .scalc-seg__b').forEach(function (b) { var on = b.getAttribute('data-ar') === state.ar; b.classList.toggle('is-on', on); b.setAttribute('aria-pressed', on ? 'true' : 'false'); }); }
        CHT.system.note(root, 'Screen size pre-filled from My System');
      }
    }
  } catch (e) {}
  setLockUI(); render();
  _scReady = true;
  try {
    if (window.CHT && CHT.system) root.addEventListener('input', function () {
      clearTimeout(_scT);
      _scT = setTimeout(function () { var d = dims(); CHT.system.set('screen', { diag: Math.round(d.D / 2.54), ar: state.ar }, 'screen'); }, 900);
    });
  } catch (e) {}
  track('view', scSnapshot());
})();
}
